import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { submitQuoteToBackend } from '../../../Services/quoteSubmission'

const FinalizationForm = () => {
  const navigate = useNavigate();
  
  // États pour le formulaire
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
    site_address: '',
    postal_code: '',
    city: '',
    delivery_instructions: '',
    comments: '',
    need_installer: false,
    be_reminded: false
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [error, setError] = useState(null);

  // Récupérer les données depuis Redux
  const selectedProducts = useSelector(state => state.selectedProducts.selectedProducts);
  const userInputs = useSelector(state => state.selectedProducts.userInputs);
  
  // Debug: Afficher les données récupérées
  console.log('🔍 FinalizationForm - selectedProducts:', selectedProducts);
  console.log('🔍 FinalizationForm - userInputs:', userInputs);
  console.log('🔍 FinalizationForm - selectedProducts.length:', selectedProducts?.length);

  // Gestion des changements de formulaire
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Soumission du devis
  const handleSubmitQuote = async () => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    setSubmitStatus(null);
    setError(null);
    
    try {
      console.log('=== DÉBUT SOUMISSION DEVIS ===');
      console.log('FormData:', formData);
      console.log('SelectedProducts:', selectedProducts);
      console.log('UserInputs:', userInputs);
      
      const result = await submitQuoteToBackend(formData, selectedProducts, userInputs);
      
      setSubmitStatus('success');
      console.log('✅ Devis soumis avec succès:', result);
      
      // Stocker les données du devis dans le localStorage pour les afficher sur /terrace
      if (result && result.items) {
        // total_cost peut être 0, donc on vérifie qu'il n'est pas undefined
        const totalCost = result.total_cost !== undefined ? result.total_cost : 0;
        
        localStorage.setItem('quoteData', JSON.stringify({
          items: result.items,
          total_cost: totalCost,
          quote_id: result.quote?.id || result.id || null,
          message: result.message || null,
          status: result.status || 'success'
        }));
        console.log('📦 Données du devis stockées dans localStorage:', {
          items_count: result.items.length,
          total_cost: totalCost,
          quote_id: result.quote?.id || result.id
        });
      } else {
        console.warn('⚠️ Aucune donnée de devis à stocker dans localStorage');
        console.warn('Result:', result);
      }
      
      // Affichage du message de succès
      // alert('Votre devis a été soumis avec succès !');
      
      // Redirection vers la page /terrace après 1 seconde
      setTimeout(() => {
        navigate('/terrace');
      }, 1000);
      
    } catch (error) {
      // Si c'est un timeout, on considère que c'est un succès partiel
      if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
        setSubmitStatus('success');
        console.log('⏰ Timeout - Le devis est en cours de traitement');
        
        // Stocker un message de timeout
        localStorage.setItem('quoteData', JSON.stringify({
          message: 'Devis en cours de traitement (timeout serveur)',
          status: 'timeout',
          items: selectedProducts || [],
          total_cost: 0
        }));
        
        // Redirection vers la page /terrace après 1 seconde
        setTimeout(() => {
          navigate('/terrace');
        }, 1000);
      }
      // Si c'est l'erreur serveur connue de calcul, ne pas considérer comme succès
      else if (error.name === 'ServerCalculationError' || 
          (error.response?.status === 500 && 
           error.response?.data?.error?.includes("unsupported operand type(s) for *: 'NoneType' and 'float'"))) {
        setSubmitStatus('error');
        console.error('❌ Erreur serveur de calcul - Le devis n\'a probablement pas été sauvegardé');
        
        // Construire un message d'erreur spécifique
        const errorMessage = 'Erreur serveur lors de la sauvegarde du devis.\n\n' +
          'Une erreur s\'est produite côté serveur lors du calcul du devis.\n' +
          'Le devis pourrait ne pas avoir été sauvegardé en base de données.\n\n' +
          'Veuillez réessayer ou contacter le support si le problème persiste.';
        
        setError(errorMessage);
        console.error('❌ Erreur complète lors de la soumission:', error);
        console.error('❌ Stack trace:', error.stack);
        
        alert(`Erreur: ${errorMessage}`);
      } else {
        setSubmitStatus('error');
        
        // Construire un message d'erreur détaillé
        let errorMessage = 'Erreur lors de la soumission du devis';
        
        // Vérifier si c'est une erreur de validation spécifique
        if (error.name === 'ValidationError' || error.message?.includes('Section matching query does not exist')) {
          errorMessage = 'Erreur de validation: Une section ou un produit sélectionné n\'existe plus dans le projet.\n\n' +
            'Veuillez retourner à la sélection des produits et vérifier que tous les éléments sont toujours disponibles.\n' +
            'Il se peut que le projet ait été modifié depuis votre dernière visite.';
        } else if (error.response) {
          // Erreur avec réponse du serveur
          const status = error.response.status;
          const data = error.response.data;
          
          if (status === 400) {
            errorMessage = 'Données invalides. Veuillez vérifier les informations saisies.';
            if (data && typeof data === 'object') {
              const details = Object.entries(data)
                .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
                .join('\n');
              if (details) {
                errorMessage += `\n\nDétails: ${details}`;
              }
            }
          } else if (status === 401) {
            errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
          } else if (status === 403) {
            errorMessage = 'Accès interdit.';
          } else if (status === 404) {
            errorMessage = 'Service non trouvé. Veuillez contacter le support.';
          } else if (status === 500) {
            // Vérifier si c'est une erreur de validation dans la réponse
            if (data?.error?.includes('Section matching query does not exist') || 
                data?.error?.includes('does not exist')) {
              errorMessage = 'Erreur de validation: Une section ou un produit sélectionné n\'existe plus dans le projet.\n\n' +
                'Veuillez retourner à la sélection des produits et vérifier que tous les éléments sont toujours disponibles.';
            } else {
              errorMessage = 'Erreur serveur. Le devis pourrait avoir été sauvegardé. Veuillez vérifier.';
            }
          } else if (status >= 500) {
            errorMessage = `Erreur serveur (${status}). Veuillez réessayer plus tard.`;
          } else {
            errorMessage = `Erreur ${status}: ${data?.error || data?.message || error.message || 'Erreur inconnue'}`;
          }
          
          console.error('❌ Erreur HTTP:', {
            status,
            statusText: error.response.statusText,
            data: data,
            headers: error.response.headers
          });
        } else if (error.request) {
          // Requête envoyée mais pas de réponse
          errorMessage = 'Aucune réponse du serveur. Vérifiez votre connexion internet.';
          console.error('❌ Pas de réponse du serveur:', error.request);
        } else {
          // Erreur de configuration
          errorMessage = error.message || 'Erreur lors de la configuration de la requête.';
          console.error('❌ Erreur de configuration:', error);
        }
        
        setError(errorMessage);
        console.error('❌ Erreur complète lors de la soumission:', error);
        console.error('❌ Stack trace:', error.stack);
        
        alert(`Erreur: ${errorMessage}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className=" finalization container-fluid px-4 px-md-5 py-5 w-75">
      <form className="px-4 px-md-5 ">
        <p className="form-title mb-4 text-center text-md-start">
          Pour continuer il nous faut quelques informations
        </p>
        <p className="form-text mb-2 text-center text-md-start">
          <Link to="#">Connectez-vous</Link>, créez un compte ou remplissez ce formulaire et recevez
          <br className="d-none d-md-block" />
          votre devis par mail
        </p>
        <div className="row row-cols-1 row-cols-md-2 g-3">
          <div className="col">
            <input 
              type="text" 
              name="name"
              placeholder="Nom" 
              className="p-3 w-100" 
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col">
            <input 
              type="email" 
              name="email"
              placeholder="Email" 
              className="p-3 w-100" 
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col">
            <input 
              type="text" 
              name="postal_code"
              placeholder="Code postal" 
              className="p-3 w-100" 
              value={formData.postal_code}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col">
            <input 
              type="tel" 
              name="phone_number"
              placeholder="Numéro de téléphone" 
              className="p-3 w-100" 
              value={formData.phone_number}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="mt-4">
          <span className="form-title">Avez-vous besoin d'un poseur ?</span>
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center py-3">
            <div className="checkbox-container me-3">
              <input 
                type="checkbox" 
                name="need_installer"
                className='custom-checkbox'
                checked={formData.need_installer}
                onChange={handleInputChange}
              />
            </div>
            <span className="form-title mx-md-3">Oui</span>
            <div className=" checkbox-container">
              <input 
                type="checkbox" 
                className='custom-checkbox'
                checked={!formData.need_installer}
                onChange={() => setFormData(prev => ({ ...prev, need_installer: false }))}
              />
            </div>
            <span className="form-title mx-md-3">Non</span>
          </div>
        </div>
        <div className="my-4">
          <span className="form-title">
            Souhaitez-vous être rappelé par un conseiller ?
          </span>
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center py-3">
            <div className=" checkbox-container">
              <input 
                type="checkbox" 
                name="be_reminded"
                className='custom-checkbox'
                checked={formData.be_reminded}
                onChange={handleInputChange}
              />
            </div>
            <span className="form-title mx-md-3">Oui</span>
            <div className=" checkbox-container">
              <input 
                type="checkbox" 
                className='custom-checkbox'
                checked={!formData.be_reminded}
                onChange={() => setFormData(prev => ({ ...prev, be_reminded: false }))}
              />
            </div>
            <span className="form-title mx-md-3">Non</span>
          </div>
        </div>
        <input 
          type="text" 
          name="site_address"
          placeholder="Adresse du chantier" 
          className="p-3 w-100" 
          value={formData.site_address}
          onChange={handleInputChange}
          required
        />
        <div className="row row-cols-1 row-cols-md-2 g-3 mt-4">
          <div className="col">
            <input 
              type="text" 
              name="postal_code"
              placeholder="Code postal" 
              className="p-3 w-100" 
              value={formData.postal_code}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col">
            <input 
              type="text" 
              name="city"
              placeholder="Ville" 
              className="p-3 w-100" 
              value={formData.city}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="my-3">
          <textarea
            name="delivery_instructions"
            rows={4}
            cols={50}
            placeholder="Instruction livraison"
            className="p-3 w-100"
            value={formData.delivery_instructions}
            onChange={handleInputChange}
          />
        </div>
        <div className="mt-4">
          <span className="form-title">
            Avez-vous des remarques à ajouter sur votre projet ?
          </span>
        </div>
        <div className="mt-3">
          <textarea
            name="comments"
            rows={4}
            cols={50}
            placeholder="Ajoutez votre commentaire ici"
            className="p-3 w-100"
            value={formData.comments}
            onChange={handleInputChange}
          />
        </div>
        
        {/* Messages de statut */}
        {submitStatus === 'success' && (
          <div className="alert alert-success mt-3">
            <i className="fas fa-check-circle me-2"></i>
            Votre devis a été soumis avec succès !
          </div>
        )}
        
        {isSubmitting && (
          <div className="alert alert-info mt-3">
            <i className="fas fa-spinner fa-spin me-2"></i>
            Soumission en cours... Veuillez patienter (cela peut prendre jusqu'à 60 secondes)
          </div>
        )}
        
        {submitStatus === 'error' && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-triangle me-2"></i>
            Erreur lors de la soumission du devis. 
            <br />
            <small>{error}</small>
          </div>
        )}
        
        <div className="d-flex justify-content-center justify-content-md-start mt-5 gap-3">
          <button 
            type="button"
            className="btn btn-secondary px-3 rounded-0"
            onClick={handleSubmitQuote}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Soumission...' : 'Voir mon devis'}
          </button>
          
          {/* <button 
            type="button"
            className="btn btn-outline-info px-3 rounded-0"
            onClick={() => {
              console.log('=== TEST DIAGNOSTIC ===');
              console.log('FormData:', formData);
              console.log('SelectedProducts:', selectedProducts);
              console.log('UserInputs:', userInputs);
              console.log('=== FIN TEST ===');
            }}
          >
            Test Diagnostic
          </button> */}
        </div>
      </form>
    </div>
  )
}

export default FinalizationForm